import Image from 'app/Components/Shared/Image/image';
import TextInput from '../../../Shared/TextInput/TextInput';
import Checkbox from '../../../Shared/CheckBox/Checkbox';
import React, {useState, useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import {errorTxt, DWHMessageText, DwhActionType, DWHStatus, transferOption} from '../Constant/Constant';
import {setCurrentPopUp, setCurrentStep, setOrgAccountDetails, transferBussinessCustomer} from '../TransferOrganizationAccountSlice';
import BtnSubmitValidation from '../../../Shared/Buttons/BtnSubmitValidation';
import {validateInput, TextInputEnum} from '../../../../utilities/validation/InputValidation';
import {dwhGeneralReport} from '../Reports/dwhReports';

const EsimConfirmation = (props) => {
  const [mail, setMail] = useState('');
  const [confirmMail, setConfirmMail] = useState('');
  const [activationConfirmed, setActivationConfirmed] = useState(false);
  useEffect(() => {
    dwhGeneralReport({
      data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
      status: DWHStatus.Ongoing,
      messageText: DWHMessageText.ESIMInstructionsDisplayed,
      actionType: DwhActionType.ESIMInstructionsPage,
    });
  }, []);

  const [errors, setErrors] = useState({
    mail: '',
    confirmMail: '',
  });

  const mailRef = useRef();
  const confirmEmailRef = useRef();

  const goToNextPage = async () => {
    var errMail = validateInput(mail, TextInputEnum.Mail);
    var errConfirmationMail = !errMail ? validateSecondMail(confirmMail) : '';
    setErrors({...errors, mail: errMail, confirmMail: errConfirmationMail});
    dwhGeneralReport({
      data: {...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails},
      status: DWHStatus.Ongoing,
      messageText: DWHMessageText.ESIMInstructionsBtnClick,
      actionType: DwhActionType.ESIMInstructionsPage,
    });
    if (!errMail && !errConfirmationMail && activationConfirmed) {
      props.setOrgAccountDetails({email: mail});
      await props.transferBussinessCustomer();
    }
  };

  const validateSecondMail = (confirmMailVal) => {
    var errMail = validateInput(confirmMailVal, TextInputEnum.Mail);
    if (errMail == '') {
      errMail = confirmMailVal != mail ? errorTxt.confirmationMail : '';
    }
    return errMail;
  };

  return (
    <div className='esimConfirmation stepContainer'>
      <div className='L_Title'>
        {' '}
        לאן לשלוח את ההוראות
        <br />
        להפעלת ה-eSIM?
      </div>

      <TextInput
        value={mail}
        error={errors.mail}
        id='mail'
        placeholder='דוא"ל'
        onChange={(e) => {
          setErrors({...errors, mail: validateInput(e.target.value, TextInputEnum.Mail)});
          setMail(e.target.value);
        }}
        required='required'
        onCopy={(e) => e.preventDefault()}
        onCut={false}
        ref={mailRef}
      />

      <TextInput
        value={confirmMail}
        error={errors.confirmMail}
        disabled={!mail || errors.mail}
        id='confirmMail'
        placeholder='אימות דוא"ל'
        onChange={(e) => {
          setErrors({...errors, confirmMail: validateSecondMail(e.target.value)});
          setConfirmMail(e.target.value);
        }}
        onPaste={(e) => e.preventDefault()}
        required='required'
        ref={confirmEmailRef}
      />

      <div className='info'>
        <div className='textWithIcon S_Title'>
          <Image src={require('../icons/light.svg')} />
          <span>
            לתשומת ליבך, בלחיצה על <span className='bold'>יצירת הזמנה</span>
            <br /> יקרו הדברים הבאים:
          </span>
        </div>
        <ol>
          <li>הלקוח יקבל הוראות הפעלה ל-eSIM</li>
          {props.data.selectedTransferOption == transferOption.niud && <li>הלקוח יקבל הודעה לניוד</li>}
          <li>המנוי יתחיל להיות פעיל</li>
        </ol>
      </div>
      <div className='checkBox'>
        <Checkbox
          id='terms-checkbox'
          onCheck={() => setActivationConfirmed(true)}
          onUncheck={() => setActivationConfirmed(false)}
          checked={activationConfirmed}>
          <span className='S_Title'> אישור הפעלת המנוי</span>
        </Checkbox>
      </div>

      <BtnSubmitValidation
        text={'ליצירת הזמנה'}
        disableReasonText={mail && confirmMail && !activationConfirmed ? errorTxt.ActivationSubscriptionNotChecked : ''}
        onclick={() => {
          goToNextPage();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  transferBussinessCustomer,
  setCurrentPopUp,
  setCurrentStep,
  setOrgAccountDetails,
};
export default connect(mapStateToProps, mapDispatchToProps)(EsimConfirmation);
